import { QueryClient } from '@tanstack/react-query';

/** Stale time for frequently changing data (PR lists, notifications, CI status) */
export const FREQUENT_STALE_TIME = 30_000; // 30 seconds

/** Stale time for infrequently changing data (repos, profile, branches) */
export const INFREQUENT_STALE_TIME = 300_000; // 5 minutes

/**
 * Computes exponential backoff delay for retry attempts.
 * Formula: min(baseDelay * 2^attempt, maxDelay)
 * Default: 1000ms, 2000ms, 4000ms
 */
export function retryDelay(attempt: number): number {
  const baseDelayMs = 1000;
  const maxDelayMs = 4000;
  return Math.min(baseDelayMs * Math.pow(2, attempt), maxDelayMs);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay,
      staleTime: FREQUENT_STALE_TIME,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
